<div class="progress-bar-container" [ngClass]="status">
  <div class="progress-bar-line-wrapper">
    <div class="progress-bar-line"></div>
    <div class="progress-bar-subline progress-bar-inc"></div>
    <div class="progress-bar-subline progress-bar-dec"></div>
  </div>
  <div *ngIf="progressMessage !== ''" class="progress-bar-line-message">
    <i class="fa" [ngClass]="progressIcon"></i>
    <div>{{ progressMessage | lsTranslate }}</div>
  </div>
</div>
<div
  i18n="Task Status|Task status when everything was successful @@taskStatusSuccessful"
  id="Import successful"
  ls-dynamic-translation
>
  Import successful
</div>
<div
  i18n="Task Status|Task status when the task failed @@taskStatusFailed"
  id="Import failed"
  ls-dynamic-translation
>
  Import failed
</div>
<div
  i18n="Task Status|Task status when there are warnings @@taskStatusWarning"
  id="Imported with errors"
  ls-dynamic-translation
>
  Imported with errors
</div>
